import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { ajax_wrapper, get_global_state } from 'functions'; // get_global_state might not be needed if slug comes from HOC
import { Link, useParams } from 'react-router-dom';

// Copied from BlogListPage.js
const getAuthorDisplayName = (email) => { 
    if (!email) return '';
    switch (email) {
        case 'andrew@yourhomebase.co':
            return 'Andrew Li'; // As per user's update in other file
        case 'ian@yourhomebase.co':
            return 'Ian Tan'; // As per user's update in other file
        case 'jeremy@yourhomebase.co':
            return 'Jeremy Thiesen'; // As per user's update in other file
        case 'dmiller89@gmail.com':
            return 'Dave Miller'; 
        default:
            const namePart = email.split('@')[0];
            if (namePart) {
                return namePart.charAt(0).toUpperCase() + namePart.slice(1);
            }
            return email;
    }
};

// HOC to inject URL parameters into class components
const withRouterParams = (WrappedComponent) => (props) => {
    const params = useParams();
    return <WrappedComponent {...props} params={params} />;
};

class ArticleDetailPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            article: null,
            loading: true,
            error: null,
        };
        this.loadArticle = this.loadArticle.bind(this);
    }

    componentDidMount() {
        const { slug } = this.props.params; // Get slug from HOC
        if (slug) {
            this.fetchArticle(slug);
        } else {
            this.setState({ error: 'Article slug not found.', loading: false });
        }
    }

    fetchArticle(slug) {
        this.setState({ loading: true, error: null });
        ajax_wrapper('GET', `/api/blog/public/articles/${slug}/`, {}, this.loadArticle);
    }

    loadArticle(response) {
        if (response && !response.error && response.slug) { // Check for slug to ensure it's a valid article object
            this.setState({ article: response, loading: false });
        } else if (response && response.detail === "Not found.") { // DRF default 404
             this.setState({ error: 'Article not found.', loading: false });
        } else if (response && response.error) {
            this.setState({ error: response.error, loading: false });
        } else {
            this.setState({ error: 'Failed to load article.', loading: false });
        }
    }

    renderSocialShare(article) {
        if (!article) return null;
        const shareUrl = window.location.href;
        const title = encodeURIComponent(article.title);

        const socialContainerStyle = {
            marginTop: '20px',
            paddingTop: '15px',
            borderTop: '1px solid #eee',
        };
        const socialLinkStyle = {
            marginRight: '10px',
            textDecoration: 'none',
            padding: '5px 10px',
            border: '1px solid #ccc',
            borderRadius: '3px',
            color: '#333',
            backgroundColor: '#f8f8f8'
        };

        return (
            <div style={socialContainerStyle}>
                <strong>Share this article:</strong>
                <a href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${title}`}
                   target="_blank" rel="noopener noreferrer" style={socialLinkStyle}>
                    Twitter
                </a>
                <a href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                   target="_blank" rel="noopener noreferrer" style={socialLinkStyle}>
                    Facebook
                </a>
                <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${title}`}
                   target="_blank" rel="noopener noreferrer" style={socialLinkStyle}>
                    LinkedIn
                </a>
            </div>
        );
    }

    render() {
        const { article, loading, error } = this.state;

        const containerStyle = {
            maxWidth: '960px',
            margin: '0 auto',
            padding: '20px'
        };

        const loadingStyle = {
            textAlign: 'center',
            fontSize: '1.2em',
            padding: '50px'
        };

        const errorStyle = {
            color: 'red',
            textAlign: 'center',
            padding: '20px',
            border: '1px solid red',
            backgroundColor: '#ffeeee'
        };
        
        const imageStyle = {
            maxWidth: '100%',
            height: 'auto',
            borderRadius: '5px',
            marginBottom: '20px'
        };
        
        const titleStyle = {
            fontSize: '2em',
            marginBottom: '15px'
        };

        const metaStyle = {
            fontSize: '0.9em',
            color: '#666',
            marginBottom: '20px'
        };
        
        const contentStyle = {
            lineHeight: '1.6',
            fontSize: '1.1em'
        };

        if (loading) {
            return <div style={loadingStyle}>Loading article...</div>;
        }

        if (error) {
            return (
                <div style={containerStyle}>
                     <Helmet>
                        <title>Error | YourHomeBase Blog</title>
                    </Helmet>
                    <p style={errorStyle}>Error: {error}</p>
                    <Link to="/blog">Back to Blog List</Link>
                </div>
            );
        }

        if (!article) {
            // Should be covered by error state, but as a fallback
            return (
                <div style={containerStyle}>
                    <Helmet>
                        <title>Article Not Found | YourHomeBase Blog</title>
                    </Helmet>
                    <p>Article not found.</p>
                    <Link to="/blog">Back to Blog List</Link>
                </div>
            );
        }

        return (
            <div style={containerStyle}>
                <Helmet>
                    <title>{`${article.seo_meta_title || article.title} | YourHomeBase Blog`}</title>
                    {article.seo_meta_description && (
                        <meta name="description" content={article.seo_meta_description} />
                    )}
                </Helmet>

                <Link to="/blog">&laquo; Back to Blog List</Link>

                <h1 style={titleStyle}>{article.title}</h1>
                <p style={metaStyle}>
                    Published on: {new Date(article.publication_date).toLocaleDateString()}
                    {article.author_email && ` by ${getAuthorDisplayName(article.author_email)}`}
                    <br/>
                    Last updated: {new Date(article.updated_at).toLocaleDateString()}
                </p>

                {article.featured_image && (
                    <img src={article.featured_image} alt={article.title} style={imageStyle} />
                )}

                <div style={contentStyle} dangerouslySetInnerHTML={{ __html: article.content }} />
                
                {this.renderSocialShare(article)}
            </div>
        );
    }
}

export default withRouterParams(ArticleDetailPage); 